goog.provide("shadow.js.shim.module$dayjs$plugin$customParseFormat");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$customParseFormat");
shadow.js.shim.module$dayjs$plugin$customParseFormat = shadow.js.nativeProvides["dayjs/plugin/customParseFormat"] = require("dayjs/plugin/customParseFormat");
module$shadow_js_shim_module$dayjs$plugin$customParseFormat.default = shadow.js.shim.module$dayjs$plugin$customParseFormat;
